module.exports = __webpack_public_path__ + "img/livelo-color.60eae94c.png";